import { Link } from "react-router-dom";
import { useState } from "react";
import { useHistory } from "react-router";
import {
  requestPasswordResetOtp,
  verifyEmailOtp,
} from "./utilities/Authentication";
import { statusFailure } from "./Constant";

export default function Forgot() {
  const history = useHistory();
  const [step, setStep] = useState(1);
  const [errorState, setErrorState] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [challengeId, setChallengeId] = useState("");

  async function sendOtp(e) {
    e.preventDefault();
    try {
      const response = await requestPasswordResetOtp({ email });
      if (response.status !== statusFailure && response.data?.challengeId) {
        setChallengeId(response.data.challengeId);
        setStep(2);
      } else {
        setErrorState(response.message || "Unable to send OTP.");
      }
    } catch (error) {
      setErrorState(error?.response?.data?.message || "Unable to send OTP.");
    }
  }

  async function verifyOtp(e) {
    e.preventDefault();
    try {
      const response = await verifyEmailOtp({ challengeId, otp });
      if (response.status !== statusFailure && response.data?.verifiedToken) {
        localStorage.setItem(
          "passwordResetEmailFlow",
          JSON.stringify({
            email,
            verifiedToken: response.data.verifiedToken,
          })
        );
        history.push("/update-password");
      } else {
        setErrorState(response.message || "Invalid OTP.");
      }
    } catch (error) {
      setErrorState(error?.response?.data?.message || "Invalid OTP.");
    }
  }

  return (
    <>
      {step === 1 ? (
        <section className="login_page">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12 order_2">
                <div className="left_content">
                  <h2>
                    Bring <span className="text-red">Stories</span> to{" "}
                    <div className="text-red sliderCurveText">Life</div>
                  </h2>
                  <p>
                    Start for free and get attractive contests from the community
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 p-0 order_1">
                <div className="login_page_content pt-110">
                  <h2>Forgot / Set Password</h2>
                  <p>Please enter your registered email.</p>
                  <div className="form">
                    <form className="mt-110" onSubmit={sendOtp}>
                      <div className="row">
                        <div className="f_class">
                          <div className="col-lg-10 col-md-6 col-10 p-0">
                            <input
                              type="email"
                              className="border_none form-control"
                              placeholder="Enter your email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            {errorState ? (
                              <div className="text-danger error-msg-text">
                                {errorState}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="login_btn text-center mt-110">
                        <button type="submit" className="btn">
                          Send OTP
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section className="login_page">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12 order_2">
                <div className="left_content">
                  <h2>
                    Bring <span className="text-red">Stories</span> to{" "}
                    <div className="text-red sliderCurveText">Life</div>
                  </h2>
                  <p>
                    Start for free and get attractive contests from the community
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 p-0 order_1">
                <div className="login_page_content pt-110">
                  <h2>Enter OTP and Verify</h2>
                  <p>Please enter the 6-digit OTP sent to your email.</p>
                  <div className="form">
                    <form className="mt-110" onSubmit={verifyOtp}>
                      <div className="row justify-content-center">
                        <div className="col-lg-12 col-md-12 col-12">
                          <input
                            type="text"
                            className="form-control"
                            maxLength={6}
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            placeholder="Enter 6-digit OTP"
                          />
                          <div className="number_resent">
                            <Link to="#" onClick={() => setStep(1)}>
                              Change email
                            </Link>
                          </div>
                          {errorState ? (
                            <div className="text-danger error-msg-text">
                              {errorState}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="login_btn text-center mt-110">
                        <button type="submit" className="btn">
                          Verify
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}